import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { listPartnerFeeBands, upsertPartnerFeeBands, type PartnerFeeBand } from "../lib/partnerFees";
import { usePartnerSessionStore } from "../lib/partnerAuth";

function usePartnerId() {
  return usePartnerSessionStore((s) => s.session?.partnerId ?? null);
}

export function usePartnerFeeBands() {
  const partnerId = usePartnerId();
  return useQuery({
    queryKey: ["partner-fee-bands", partnerId],
    enabled: !!partnerId,
    queryFn: () => listPartnerFeeBands(partnerId!),
  });
}

export function useSavePartnerFeeBands() {
  const partnerId = usePartnerId();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (bands: PartnerFeeBand[]) => {
      if (!partnerId) throw new Error("no_partner");
      return upsertPartnerFeeBands(partnerId, bands);
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["partner-fee-bands", partnerId] });
    },
  });
}
